// extracted by mini-css-extract-plugin
export default {"body":"MindoDalamAngka_body__gUBKZ","title":"MindoDalamAngka_title__74I9a","text":"MindoDalamAngka_text__3nKIT","wrapRow":"MindoDalamAngka_wrapRow__arnL4"};